import React, { useState } from 'react';
import './gallery.css';
import apj from '../assets/galleryimages/apj-akbs.jpg';
import nsr from '../assets/galleryimages/nilam-sanjeeva-akbs.jpg';
import vvg from '../assets/galleryimages/vv-giri-mammen-mathew.jpg';
import ipn from '../assets/galleryimages/indira-gandhi-akbs.jpg';
import st1 from '../assets/galleryimages/state leadership camp.jpg';
import PTA1 from '../assets/galleryimages/Praatheeksha_nature_camp.jpg';
import VOH1 from '../assets/galleryimages/Visiting old-age home.jpg';
import PTA2 from '../assets/galleryimages/pratheeksha_natue_Camp_pTA.jpg';
import PTA3 from '../assets/galleryimages/pratheeksha camp.jpg';
import MGXP1 from '../assets/galleryimages/magic_plannet.jpg';
import MGXP2 from '../assets/galleryimages/magic_plannet2.jpg';
import OCH from '../assets/galleryimages/STATE_leaders_paying_homege_formr Cm.jpg'
import PSC from '../assets/galleryimages/BALAJANA_SAKHYAM_PEECHI_CAMP_GROUP_DSC_2918.jpg';
import PSC1 from '../assets/galleryimages/statecamp2.JPG';
import PSC2 from '../assets/galleryimages/statecmp1.JPG';
import PSC3 from '../assets/galleryimages/Peechi_camp.jpg';
import PNC from '../assets/galleryimages/pratheeksha_natue_Camp_pTA.jpg';
import JIM1 from '../assets/galleryimages/JIM_6737.jpg';
import JIM2 from '../assets/galleryimages/JIM_6755.jpg';
import JIM3 from '../assets/galleryimages/JIM_6795.jpg';

const images = [
  { src: apj, alt: 'APJ Abdul Kalam at AKBS', description: 'APJ Abdul Kalam at AKBS event', date: '2002' },
  { src: nsr, alt: 'Nilam Sanjeeva Reddy at AKBS', description: 'Nilam Sanjeeva Reddy at AKBS', date: '1980' },
  { src: ipn, alt: 'Indira Gandhi at AKBS', description: 'Indira Gandhi addressing AKBS', date: '1976' },
  { src: vvg, alt: 'VV Giri and Mammen Mathew', description: 'VV Giri with Mammen Mathew', date: '1972' },
  { src: JIM1, alt: '', description: ' ', date: '2024' },
  { src: JIM3, alt: '', description: ' ', date: '2024' },

  { src: st1, alt: ' State Leadership Camp', description: 'State Leadership camp 2023-24', date: '2024' },
  { src: PTA1, alt: 'Pratheeksha Nature Camp 2023-24', description: 'Pratheeksha Nature Camp 2023-24', date: '2024' },
  { src: VOH1, alt: "Visiting oldage home on sakhyam's Birthday", description: "Visiting oldage home on sakhyam's Birthday, Ernakulam", date: '2002' },
  { src: PTA2, alt: 'Pratheeksha Nature Camp 2023-24', description: 'Pratheeksha Nature Camp 2023-24', date: '2024' },
  { src: PTA3, alt: 'Pratheeksha Nature Camp 2023-24', description: 'Pratheeksha Nature Camp 2023-24', date: '2024' },
  { src: MGXP1, alt: 'MAGIC PLANNET VISIT 2023-24', description: 'Magic Plannet Visit 2023-24', date: '2024' },
  { src: MGXP2, alt: 'MAGIC PLANNET VISIT 2023-24', description: 'Magic Plannet Visit 2023-24', date: '2024' },
  { src: OCH, alt: 'State leaders paying homage to former Chief Minister', description: 'State leaders paying homage to former Chief Minister Shri Oommen Chandy', date: '2023' },
  { src: PSC, alt: 'Peechi State Camp 2024', description: ' State Camp , Peechi,Thrissur 2023-24', date: '2024' },
  { src: PSC1, alt: 'Peechi State Camp 2024', description: ' Pratheeksha Nature Camp 2023-24', date: '2024' },
  { src: PSC2, alt: 'Peechi State Camp 2024', description: ' Pratheeksha Nature Camp 2023-24', date: '2024' },
  { src: PSC3, alt: 'Peechi State Camp 2024', description: ' State Camp, Peechi,Thrissur 2023-24', date: '2024' },
  { src: PNC, alt: 'Peechi State Camp 2024', description: ' Pratheeksha Nature Camp 2023-24', date: '2024' },

];

function Gallery() {
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const openFullscreen = (image) => {
    setFullscreenImage(image);
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
  };

  return (
    <div className="gallery-page">
      <h1 className="gallery-heading">IMAGE GALLERY</h1>
      <div className="gallery-container">
        {images.map((image, index) => (
          <div key={index} className="gallery-item" onClick={() => openFullscreen(image)}>
            <img src={image.src} alt={image.alt} />
            <div className="gallery-description">
              <p className="description-text">{image.description}</p>
              <p className="gallery-date">{image.date}</p>
            </div>
          </div>
        ))}
      </div>

      {fullscreenImage && (
        <div className="fullscreen-overlay" onClick={closeFullscreen}>
          <div className="fullscreen-content">
            <img src={fullscreenImage.src} alt={fullscreenImage.alt} className="fullscreen-img" />
            <div className="fullscreen-description">
              <h2>{fullscreenImage.description}</h2>
              <p className="fullscreen-date">{fullscreenImage.date}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
